export enum NotificationType {
    Post = 0,
    Request = 1,
    Massage = 2,
    Pay = 3,
}
